import React from "react";

const Review: React.FC = () => {
  return (
    <svg
      width="55"
      height="59"
      viewBox="0 0 55 59"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="55"
        height="59"
        rx="6"
        fill="url(#paint0_linear_9793_15607)"
      />
      <rect x="5" y="38" width="45" height="16" rx="4" fill="white" />
      <rect x="9" y="43" width="34" height="1.5" rx="0.75" fill="#0F2162" />
      <rect x="9" y="48" width="23" height="1.5" rx="0.75" fill="#0F2162" />
      <path
        d="M50 17.5C50 18.4788 49.2959 19.2128 48.6744 19.8606C48.3209 20.23 47.9553 20.6106 47.8175 20.9453C47.69 21.2519 47.6825 21.76 47.675 22.2522C47.6609 23.1672 47.6459 24.2041 46.925 24.925C46.2041 25.6459 45.1672 25.6609 44.2522 25.675C43.76 25.6825 43.2519 25.69 42.9453 25.8175C42.6106 25.9553 42.23 26.3209 41.8606 26.6744C41.2128 27.2959 40.4788 28 39.5 28C38.5212 28 37.7872 27.2959 37.1394 26.6744C36.77 26.3209 36.3894 25.9553 36.0547 25.8175C35.7481 25.69 35.24 25.6825 34.7478 25.675C33.8328 25.6609 32.7959 25.6459 32.075 24.925C31.3541 24.2041 31.3391 23.1672 31.325 22.2522C31.3175 21.76 31.31 21.2519 31.1825 20.9453C31.0447 20.6106 30.6791 20.23 30.3256 19.8606C29.7041 19.2128 29 18.4788 29 17.5C29 16.5212 29.7041 15.7872 30.3256 15.1394C30.6791 14.77 31.0447 14.3894 31.1825 14.0547C31.31 13.7481 31.3175 13.24 31.325 12.7478C31.3391 11.8328 31.3541 10.7959 32.075 10.075C32.7959 9.35406 33.8328 9.33906 34.7478 9.325C35.24 9.3175 35.7481 9.31 36.0547 9.1825C36.3894 9.04469 36.77 8.67906 37.1394 8.32562C37.7872 7.70406 38.5212 7 39.5 7C40.4788 7 41.2128 7.70406 41.8606 8.32562C42.23 8.67906 42.6106 9.04469 42.9453 9.1825C43.2519 9.31 43.76 9.3175 44.2522 9.325C45.1672 9.33906 46.2041 9.35406 46.925 10.075C47.6459 10.7959 47.6609 11.8328 47.675 12.7478C47.6825 13.24 47.69 13.7481 47.8175 14.0547C47.9553 14.3894 48.3209 14.77 48.6744 15.1394C49.2959 15.7872 50 16.5212 50 17.5Z"
        fill="#071443"
      />
      <path
        d="M38.5601 19.8342L36.7269 17.9243L36.7269 17.9243C36.6208 17.8138 36.4747 17.7498 36.3202 17.7498C36.1656 17.7498 36.0195 17.8138 35.9134 17.9243C35.8077 18.0345 35.75 18.1817 35.75 18.3333C35.75 18.4848 35.8077 18.6321 35.9134 18.7422L38.1532 21.0753C38.1533 21.0753 38.1533 21.0753 38.1533 21.0754C38.2058 21.13 38.2686 21.1739 38.3384 21.2041C38.4084 21.2343 38.4837 21.25 38.5601 21.25C38.6364 21.25 38.7118 21.2343 38.7817 21.2041C38.8516 21.1739 38.9144 21.13 38.9668 21.0754C38.9668 21.0753 38.9669 21.0753 38.9669 21.0753L44.0866 15.7424C44.1923 15.6323 44.25 15.485 44.25 15.3335C44.25 15.182 44.1923 15.0347 44.0866 14.9245C43.9805 14.8141 43.8344 14.75 43.6798 14.75C43.5253 14.75 43.3792 14.8141 43.2731 14.9245L43.2731 14.9245L38.5601 19.8342Z"
        fill="white"
        stroke="white"
        strokeWidth="0.5"
      />
      <defs>
        <linearGradient
          id="paint0_linear_9793_15607"
          x1="23.8121"
          y1="18.0612"
          x2="53.11"
          y2="66.5249"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9FF7EE" />
          <stop offset="1" stopColor="#8CCBFF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Review;
